import { portalPost } from "../../http";
import { LoginDataSet } from "../../../containers/WorkSpace/types";

export const getWorkSpaces = (
  username: string
): Promise<{ apps: LoginDataSet[]; status: "ok" }> => {
  // eslint-disable-next-line @typescript-eslint/camelcase
  return portalPost("multi_tenant", { user_email_or_phone: username }, {});
};
